import { gql } from '@apollo/client';

export const CREATE_PROJECT = gql`
  mutation CreateProject($project: ProjectInput!) {
    createProject(project: $project) {
      id
    }
  }
`;
